export class Recommenderbar {

    private static isRecommenderbarPresent = false;
    private static footerPaddingIsSet = false;
    private static recommenderbar: HTMLElement;
    private static recommenderbarButton: HTMLElement;
    private static recommenderbarSlideIn: HTMLElement;
    private static recommenderFadeoutClass = 'fadeOut';
    private static recommenderVisibilityHiddenClass = 'hidden';

    public static init() {
        document.addEventListener('DOMContentLoaded', Recommenderbar.onDocumentLoaded, false);
    }

    private static onDocumentLoaded() {
        Recommenderbar.recommenderbar = document.getElementById('headerbar');
        if(Recommenderbar.recommenderbar) {
            Recommenderbar.isRecommenderbarPresent = true;
            Recommenderbar.recommenderbarButton = document.getElementById('headerbar-slide-button');
            Recommenderbar.recommenderbarSlideIn = document.getElementById('headerbar-slide');
        }
    }

    public static toggleRecommenderbar(isTop : boolean) {
        if(!Recommenderbar.isRecommenderbarPresent) {
            return;
        }
        if(!Recommenderbar.footerPaddingIsSet) {
            Recommenderbar.setFooterPadding();
            Recommenderbar.footerPaddingIsSet = true;
        }
        if(isTop) {
            Recommenderbar.recommenderbar.classList.remove(Recommenderbar.recommenderVisibilityHiddenClass);
            Recommenderbar.recommenderbar.classList.remove(Recommenderbar.recommenderFadeoutClass);
        }else{
            Recommenderbar.recommenderbar.classList.add(Recommenderbar.recommenderFadeoutClass);
            if(Recommenderbar.checkIfRecommenderbarIsOpen()) {
                Recommenderbar.closeRecommenderbar();
            }
            setTimeout(function (){
                Recommenderbar.recommenderbar.classList.add(Recommenderbar.recommenderVisibilityHiddenClass);
            }, 500)
        }
    }

    private static checkIfRecommenderbarIsOpen(): boolean {
        return Recommenderbar.recommenderbarButton.classList.contains('open');
    }

    private static closeRecommenderbar() {
        Recommenderbar.recommenderbarButton.classList.remove('open');
        Recommenderbar.recommenderbarButton.classList.add('closed');
        Recommenderbar.recommenderbarSlideIn.classList.remove('in');
        Recommenderbar.recommenderbarSlideIn.classList.add('out');
    }

    private static setFooterPadding() {
        document.getElementById('footer').style.paddingBottom = '20px';
    }

}
